export const CHECK_USER = "check_user";
export const CHECK_USER_SUCCESSFUL = "check_user_successfull";
export const CHECK_USER_FAILED = "check_user_failed";
